import apiClient from './apiClient';

export const employeeService = {
  getAll: (page = 1, limit = 10, filters = {}) => apiClient.get('/employees', {
    params: {
      page,
      limit,
      ...filters
    }
  }),
  getCurrent: () => apiClient.get('/employees/me'),
  getById: (id) => apiClient.get(`/employees/${id}`),
  create: (data) => apiClient.post('/employees', data),
  update: (id, data) => apiClient.put(`/employees/${id}`, data),
  delete: (id) => apiClient.delete(`/employees/${id}`)
};

export default employeeService;
